import {useContentHelpers} from '@nuxt-marketing-module/composables/useContentHelpers';
import type {RichTextField, RTNode, Slice} from '@prismicio/types';
import type {ArticleContentSlice} from '@prismicio-types';

type SliceTitle = {
    content: any;
    id: string;
};

export function useSlicesTitles() {
    const {titleFieldToId} = useContentHelpers();

    function getSlicesTitles(slices: Slice[]): SliceTitle[] {
        const titlesArray: SliceTitle[] = [];
        slices.forEach((slice: Slice) => {
            if (slice.slice_type === 'article_content') {
                titlesArray.push(..._getArticleContentTitles(slice as ArticleContentSlice));
            } else {
                titlesArray.push(..._getOtherSliceTitle(slice));
            }
        });

        return titlesArray;
    }

    function _getArticleContentTitles(articleContentSlice: ArticleContentSlice): SliceTitle[] {
        return articleContentSlice.primary?.content
            .filter((field) => _isHeadingField(field))
            .map((title) => ({content: title, id: titleFieldToId([title])}))
            .filter((title) => title.id) as SliceTitle[];
    }

    function _getOtherSliceTitle(otherSlice: Slice): SliceTitle[] {
        let title;

        // Content maybe an array of heading fields or a single heading field
        if (Array.isArray(otherSlice.primary?.title)) {
            const headingFields = otherSlice.primary?.title.filter((field) => _isHeadingField(field));
            if (headingFields.length > 0) {
                title = headingFields[0];
            }
        } else if (otherSlice.primary?.title && typeof otherSlice.primary?.title === 'object') {
            title = otherSlice.primary?.title;
        }

        if (!title) {
            return [];
        }

        const id = titleFieldToId(otherSlice.primary?.title as RichTextField);

        if (!id) {
            return [];
        }

        return [{content: title, id}];
    }

    function _isHeadingField(field: RTNode): boolean {
        return field.type && ['heading2', 'heading3'].includes(field.type);
    }

    return {
        getSlicesTitles,
    };
}
